// @TODO(sruddy) these will be added to @joincivil/utils adding here temporarily till we get that bumped

const FAQ_BASE_URL = "https://help.civil.co";

export const urlConstants = {
  HOME: "https://civil.co",
  HELP: "https://help.civil.co",
  TERMS: "https://learn.civil.co/terms",
  PRIVACY_POLICY: "https://learn.civil.co/privacy-policy",

  // FAQ Boosts
  FAQ_BOOSTS: FAQ_BASE_URL + "/hc/en-us/categories/360001939731-Boosts",
  FAQ_BOOST_WITHDRAWL:
    FAQ_BASE_URL + "/hc/en-us/articles/360030195272-How-do-I-withdraw-my-ETH-proceeds-once-a-Boost-has-ended-",
  FAQ_BOOST_SUPPORTERS: FAQ_BASE_URL + "/hc/en-us/sections/360005752331-Supporters",
  FAQ_WALLETS: FAQ_BASE_URL + "/hc/en-us/sections/360003838452-Wallets",
  FAQ_CVL_TOKENS: FAQ_BASE_URL + "/hc/en-us/articles/360016409251-What-are-Civil-tokens-CVL-",
  FAQ_BOOST_HOW_TO_SUPPORT: FAQ_BASE_URL + "/hc/en-us/articles/360030520791-How-do-I-support-a-Boost-",
  FAQ_BOOST_WHEN_CHARGED: FAQ_BASE_URL + "/hc/en-us/articles/360030521331-When-will-my-payment-be-charged-",
  FAQ_BOOST_CHARGED_IF_BOOST_FAILS:
    FAQ_BASE_URL + "/hc/en-us/articles/360030521471-Will-I-be-charged-if-the-Boost-does-not-hit-its-target-goal-date-",
  FAQ_BOOST_WHAT_PAYMENT_DATA:
    FAQ_BASE_URL + "/hc/en-us/articles/360030521711-What-information-can-others-see-about-my-payment-",
};
